module.exports = __webpack_public_path__ + "media/rendering/renderingSlide3-157596dc.png";